import { createFileRoute } from '@tanstack/react-router';

import { VulglanceTermsPage } from '@/features/vulglance/routes/TermsPage';

export const Route = createFileRoute('/vulglance/terms')({
  component: VulglanceTermsPage,
});
